import { useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import BoatSection from "@/components/site/BoatSection";
import Excursions from "@/components/site/Excursions";
import HowItWorks from "@/components/site/HowItWorks";
import BookingForm from "@/components/site/BookingForm";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import { useLang, CONTACT } from "@/lib/i18n";
import { MessageCircle, Mail } from "lucide-react";

export default function Home() {
  const { t } = useLang();
  const [excursion, setExcursion] = useState("classic");
  const choose = (id) => {
    setExcursion(id);
    document.getElementById("reserver")?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div data-testid="home-page">
      <Header />
      <Hero />
      <BoatSection />
      <Excursions onChoose={choose} />
      <HowItWorks />
      <section id="reserver" className="scroll-mt-28 max-w-7xl mx-auto px-5 sm:px-10 pb-28 grid lg:grid-cols-12 gap-12" data-testid="booking-section">
        <div className="lg:col-span-4">
          <div className="gold-rule mb-8 w-24" />
          <h2 className="font-display text-4xl sm:text-5xl mb-5">{t.form_title}</h2>
          <p className="text-slate-400 leading-relaxed">{t.form_sub}</p>
          <div className="flex flex-col gap-3 mt-10">
            <a href={CONTACT.whatsappLink} target="_blank" rel="noreferrer" data-testid="cta-whatsapp-btn"
              className="inline-flex items-center justify-center gap-3 bg-[#25D366] text-[#050B14] px-6 py-4 font-medium tracking-wide hover:bg-[#3be37a] hover:-translate-y-0.5 transition-[background-color,transform] duration-300">
              <MessageCircle className="w-5 h-5" />{t.cta_whatsapp}
            </a>
            <a href={`mailto:${CONTACT.email}`} data-testid="cta-email-btn"
              className="inline-flex items-center justify-center gap-3 border border-[#D4AF37] text-[#D4AF37] px-6 py-4 tracking-wide hover:bg-[#D4AF37] hover:text-[#050B14] transition-colors duration-300">
              <Mail className="w-5 h-5" />{t.cta_email}
            </a>
          </div>
        </div>
        <div className="lg:col-span-8 bg-[#0A1325] border border-white/10 p-6 sm:p-12">
          <BookingForm excursion={excursion} setExcursion={setExcursion} />
        </div>
      </section>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
